<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="名片列表" name="cardlist"></el-tab-pane>
      <el-tab-pane label="标签列表" name="label"></el-tab-pane>
      <el-tab-pane label="分类列表" name="category"></el-tab-pane>
      <el-tab-pane label="基础设置" name="setting"></el-tab-pane>
    </el-tabs>

    <!--名片列表-->
    <Cardlist v-if="activeName == 'cardlist'"></Cardlist>

    <!--基础设置-->
    <Setting v-if="activeName == 'setting'"></Setting>
    <!--分类列表-->
    <Category v-if="activeName == 'category'"></Category>
    <!-- 标签列表 -->
    <Label v-if="activeName == 'label'" type='card'></Label>
  </div>
</template>
<script>
import Cardlist from './cardlist/index';
import Setting from './setting/getSetting';
import Category from './category/index';
import Label from '@/components/label/index.vue';
export default {
  components: {
    Cardlist,
    Setting,
    Label,
    Category
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'cardlist'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/index3.vue